<template>
  <a-modal :title="form.activity_id ? '修改活动信息' : '新增活动信息'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false" width="900px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="活动标题" prop="activity_title">
        <a-input v-model="form.activity_title" placeholder="请输入活动标题" />
      </a-form-model-item>
      <a-form-model-item label="活动副标题" prop="activity_subtitle">
        <a-input v-model="form.activity_subtitle" placeholder="请输入活动副标题" />
      </a-form-model-item>
      <a-form-model-item label="活动时间" prop="activity_time_range">
        <a-range-picker v-model="form.activity_time_range" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
          :placeholder="['开始日期', '结束日期']" style="width: 100%" />
      </a-form-model-item>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" label="人数开关" prop="quantity_switch">
            <a-radio-group v-model="form.quantity_switch">
              <a-radio value="0">关闭</a-radio>
              <a-radio value="1">开启</a-radio>
            </a-radio-group>
            <div style="font-size: 12px; color: #999; margin-top: 2px;">开启后，超过人数上限将不可参与</div>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="人数上限" prop="quantity">
            <a-input-number v-model="form.quantity" :min="1" :precision="0" placeholder="请输入人数上限" style="width: 100%" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" label="投票模式" prop="model">
            <a-radio-group v-model="form.model">
              <a-radio value="1">每天</a-radio>
              <a-radio value="2">活动整个周期</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="可投数量 / (票)" prop="model_num">
            <a-input-number v-model="form.model_num" :min="1" :precision="0" placeholder="请输入可投数量"
              style="width: 100%" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" label="重复投同一人" prop="model_same">
            <a-radio-group v-model="form.model_same">
              <a-radio value="0">不能重复</a-radio>
              <a-radio value="1">能重复</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="是否上架" prop="is_show">
            <a-radio-group v-model="form.is_show">
              <a-radio value="1">上架</a-radio>
              <a-radio value="0">下架</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-form-model-item :label-col="{ span: 6 }" label="轮播图" prop="is_app">
        <MyUpload v-model="form.banner"></MyUpload>
        <span>提示：建议上传横向展示的图片(如16:9、4:3)</span>
      </a-form-model-item>
      <a-form-model-item :label-col="{ span: 6 }" label="活动介绍" prop="activity_introduction">
        <div style="border: 1px solid #ccc;">
          <Toolbar key="1" style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
          <Editor style="height: 400px; overflow-y: hidden;" v-model="form.activity_introduction"
            :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
        </div>
      </a-form-model-item>
      <a-form-model-item :label-col="{ span: 6 }" label="活动用户协议" prop="activity_xieyi">
        <div style="border: 1px solid #ccc;">
          <Toolbar key="2" style="border-bottom: 1px solid #ccc" :editor="editor2" :defaultConfig="toolbarConfig" :mode="mode" />
          <Editor style="height: 400px; overflow-y: hidden;" v-model="form.activity_xieyi"
            :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated2" />
        </div>
      </a-form-model-item>
      <a-form-model-item :label-col="{ span: 6 }" label="JSON字符串" prop="jsontext">
        <a-input v-model="form.jsontext" placeholder="" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import http from '@/api/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import MyUpload from '@/components/MyUpload/index.vue'
export default {
  components: { Editor, Toolbar, MyUpload },
  data() {
    return {
      editor: null,
      editor2: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入活动介绍...',
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              try {
                const formData = new FormData();
                formData.append('file', file);
                const res = await http({
                  url: '/admin/sys/upload',
                  method: 'post',
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                  data: formData
                })
                // 插入上传的图片url
                insertFn(res.data.url, 'image', res.data.url)
              } catch (error) {
                console.log(error);
              }
            }
          }
        }
      },
      mode: 'default',
      visible: false,
      confirmLoading: false,
      form: {
        activity_id: null,
        activity_title: "",
        activity_subtitle: "",
        activity_start: "",
        activity_end: "",
        activity_time_range: [],
        activity_introduction: "",
        quantity: 1,
        quantity_switch: "0",
        model: "1",
        model_num: 1,
        model_same: "0",
        is_show: "1",
        banner: [],
        activity_xieyi: "",
        jsontext: ""
      },
      rules: {
        activity_title: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
        ],
        activity_time_range: [
          {
            required: true,
            type: 'array',
            message: "请选择活动时间范围",
            trigger: "change",
          },
        ],
        quantity: [
          {
            required: true,
            type: 'number',
            message: "请输入人数上限",
            trigger: "blur",
          },
        ],
        model_num: [
          {
            required: true,
            type: 'number',
            message: "请输入可投数量",
            trigger: "blur",
          },
        ],
        is_show: [
          {
            required: true,
            message: "请选择是否上架",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
    const editor2 = this.editor2
    if (editor2 == null) return
    editor2.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreated2(editor) {
      this.editor2 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    init(id) {
      this.visible = true;
      this.form.activity_id = id;
      if (id) {
        this.$http({
          url: "/admin/activity/info",
          method: "post",
          data: {
            activity_id: id,
          },
        }).then((res) => {
          // 从完整的日期时间中提取日期部分
          let startDate = "";
          let endDate = "";
          if (res.data.activity_start) {
            startDate = res.data.activity_start.split(' ')[0];
          }
          if (res.data.activity_end) {
            endDate = res.data.activity_end.split(' ')[0];
          }
          this.form = {
            ...res.data,
            activity_introduction: res.data.activity_introduction || "",
            activity_time_range: startDate && endDate ? [startDate, endDate] : [],
            quantity: res.data.quantity || 1,
            quantity_switch: res.data.quantity_switch || "0",
            model: res.data.model || "1",
            model_num: res.data.model_num || 1,
            model_same: res.data.model_same || "0",
            is_show: res.data.is_show || "1",
            banner: res.data.banner ? res.data.banner.split(",") : [],
            activity_xieyi: res.data.activity_xieyi || "",
            jsontext: res.data.jsontext || ""
          }
        });
      } else {
        // 重置表单
        this.form = {
          activity_id: null,
          activity_title: "",
          activity_subtitle: "",
          activity_start: "",
          activity_end: "",
          activity_time_range: [],
          activity_introduction: "",
          quantity: 1,
          quantity_switch: "0",
          model: "1",
          model_num: 1,
          model_same: "0",
          is_show: "1",
          banner: [],
          activity_xieyi: "",
          jsontext: ""
        };
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 验证时间范围
          if (!this.form.activity_time_range || this.form.activity_time_range.length !== 2) {
            this.$message.error("请选择活动时间范围");
            return false;
          }

          // 验证结束日期必须大于等于开始日期
          const startDate = new Date(this.form.activity_time_range[0]);
          const endDate = new Date(this.form.activity_time_range[1]);
          if (endDate < startDate) {
            this.$message.error("结束日期必须大于等于开始日期");
            return false;
          }

          this.confirmLoading = true;
          // 开始时间添加 00:00:00，结束时间添加 23:59:59
          const form = {
            activity_id: this.form.activity_id,
            activity_title: this.form.activity_title,
            activity_subtitle: this.form.activity_subtitle,
            activity_start: this.form.activity_time_range[0] + ' 00:00:00',
            activity_end: this.form.activity_time_range[1] + ' 23:59:59',
            activity_introduction: this.form.activity_introduction,
            quantity: this.form.quantity,
            quantity_switch: this.form.quantity_switch,
            model: this.form.model,
            model_num: this.form.model_num,
            model_same: this.form.model_same,
            is_show: this.form.is_show,
            banner: this.form.banner.join(","),
            activity_xieyi: this.form.activity_xieyi,
            jsontext: this.form.jsontext
          };
          this.$http({
            url: this.form.activity_id ? "/admin/activity/update" : "/admin/activity/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.activity_id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style></style>
